import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpSourceOperandTypeFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpSourceOperandType
 */

export class ExpSourceOperandTypeFactory {}
_ExpSourceOperandTypeFactory = ExpSourceOperandTypeFactory;
_defineProperty(ExpSourceOperandTypeFactory, "FromJSON", function (json) {
  return _ExpSourceOperandTypeFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpSourceOperandTypeFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'label': json['label'],
    'description': json['description'],
    'categoryIDs': json['categoryIDs'] === null || json['categoryIDs'] === undefined ? json['categoryIDs'] : json['categoryIDs'],
    'valueTypeIDs': json['valueTypeIDs'] === null || json['valueTypeIDs'] === undefined ? json['valueTypeIDs'] : json['valueTypeIDs'],
    'qualifier': json['qualifier'],
    'multiple': json['multiple']
  };
});
_defineProperty(ExpSourceOperandTypeFactory, "ToJSON", function (value) {
  return _ExpSourceOperandTypeFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpSourceOperandTypeFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'label': value.label,
    'description': value.description,
    'categoryIDs': value.categoryIDs,
    'valueTypeIDs': value.valueTypeIDs,
    'qualifier': value.qualifier,
    'multiple': value.multiple
  };
});
//# sourceMappingURL=ExpSourceOperandType.js.map
